import { createSelector } from 'reselect'
import { State } from 'index'

const calendarSelector = (state: State) => state.storeCalendar

export const getStoreCurrentMonth = createSelector([calendarSelector], (state) => state.currentMonth)
export const getClosedStoreCalendars = createSelector([calendarSelector], (state) => state.closedStoreCalendars)
export const getOrderedStoreCalendars = createSelector([calendarSelector], (state) => state.orderedStoreCalendars)
export const getStoreCalendars = createSelector([calendarSelector], (state) => state.storeCalendars)
